<template>
  <section id="privacy">
    <div class="full-width-header">Privacy & Cookies</div>
    <div class="content privacy-content">
      <div class="privacy-card">
        <p class="text-body-1 privacy-text">
          We respect your privacy. This page explains how cookies and analytics are used on this website.
          You can change your cookie preferences at any time.
        </p>

        <div class="privacy-actions">
          <v-btn color="primary" class="privacy-button" @click="openPreferences">
            Cookie preferences
          </v-btn>
        </div>
      </div>

      <div class="privacy-card">
        <h2 class="text-h6 privacy-title">What we collect</h2>
        <ul class="privacy-list">
          <li>Essential cookies required for the site to function.</li>
          <li>Analytics data (if you accept all cookies) to understand site usage.</li>
        </ul>
      </div>

      <div class="privacy-card">
        <h2 class="text-h6 privacy-title">How we use analytics</h2>
        <p class="text-body-1 privacy-text">
          Analytics helps us improve the site experience. If you choose “Necessary only”, analytics is disabled
          and no analytics cookies are stored.
        </p>
      </div>

      <div class="privacy-card">
        <h2 class="text-h6 privacy-title">Contact</h2>
        <p class="text-body-1 privacy-text">
          Questions about privacy? Please use the contact options in the footer.
        </p>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import * as CookieConsent from 'vanilla-cookieconsent';

export default defineComponent({
  name: 'PrivacyView',

  setup() {
    const openPreferences = (): void => {
      CookieConsent.showPreferences();
    };

    return {
      openPreferences
    };
  }
});
</script>

<style scoped>
.privacy-content {
  display: grid;
  gap: 24px;
  padding-bottom: 40px;
}

.privacy-card {
  background: rgba(var(--v-theme-primary), 0.06);
  border-radius: 18px;
  padding: 24px;
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.2);
}

.privacy-title {
  margin-bottom: 12px;
}

.privacy-text {
  margin-bottom: 0;
  line-height: 1.6;
}

.privacy-actions {
  margin-top: 16px;
}

.privacy-button {
  font-weight: 600;
}

.privacy-list {
  margin: 0;
  padding-left: 18px;
  line-height: 1.6;
}
</style>
